/**
 * @fileoverview CenterConst const<br>
 * 本ファイルは定義書より出力されるため直接編集禁止<br>
 * 変更がある場合は定義書を変更しファイルを生成してください。
 */
'use strict';
const CenterConst = {
  /**
   * 利用可能時間リスト
   * @name ACCOUNTABLE_TIME_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  ACCOUNTABLE_TIME_LIST: {
    OPEN: '1',
    CLOSE: '2'
  },
  /**
   * 予約単位
   * @name BOOKING_UNIT
   * @constant
   * @memberOf const.CenterConst
   */
  BOOKING_UNIT: {
    MIN: 15,
    DEFAULT: 60,
    DATA: 1440
  },
  /**
   * 予約終了時刻のインデックス補正値
   * @name BOOKING_END_INDEX_ADD_NUMBER
   * @constant
   * @memberOf const.CenterConst
   */
  BOOKING_END_INDEX_ADD_NUMBER: {
    USE_TIME: 5,
    ASSIGN: 20,
    NO_ASSIGN: {
      USE_TIME: 3,
      ASSIGN: 12
    }
  },

  /**
   * 利用時間表示基準
   * @name DISPLAY_REFERENCE
   * @constant
   * @memberOf const.CenterConst
   */
  DISPLAY_REFERENCE: {
    TIME: '18:00',
    INDEX: 72,
    DISPLAY_BOX_QUANTITY: 24,
    START_INDEX_ADJUSTMENT: -4,
    DISPLAY_HEADER_TIME: 4
  },

  /**
   * 予約状況IDリスト
   * @name BOOKING_STATUS_ID_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  BOOKING_STATUS_ID_LIST: {
    // 仮予約
    TENTATIVE_BOOKING: '1',
    // 予約確定
    BOOKING_FIXED: '2',
    // 作業中
    WORKING_STATE: '3',
    // 作業終了
    FINISH_WORK: '4',
    // 未確定
    NO_BOOKING_FIXED: '6',
    // 確定
    CONFIRM: '7'
  },

  /**
   * 予約状況編集結果コード
   * @name ASSIGN_EDIT_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  ASSIGN_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // バース種別が無効
    INVALID_BERTH_CATEGORY: '2',
    // バースが無効
    INVALID_BERTH: '3',
    // 予約情報が存在しない
    NOT_EXIST_BOOKING: '4',
    // 存在しない予約ステータスを指定
    NOT_STATUS: '5',
    // 予約時間に空きなし
    FULL: '6',
    // その他エラ－
    OTHER: '9',
    //住友理工カスタマイズ
    // 開始予定時刻チェック
    START_TIME_ERROR: '7'
  },

  /**
   * お知らせステータス
   * @name NOTICE_STATUS_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  NOTICE_STATUS_LIST: {
    // 掲載前
    BEFORE: '1',
    // 掲載中
    POSTING: '2',
    // 掲載後
    AFTER: '3'
  },

  /**
   * バース種別編集結果コード
   * @name BERTH_CATEGORY_EDIT_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  BERTH_CATEGORY_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // 同名あり
    DUPLICATION: '2',
    // その他エラー
    OTHER: '9'
  },

  /**
   * 車種編集結果コード
   * @name CAR_MODEL_EDIT_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  CAR_MODEL_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // 車種名重複
    DUPLICATION: '2',
    // その他エラー
    OTHER: '9'
  },

  /**
   * 受付状況ステータスIDリスト
   * @name RECEPTION_STATUS_ID_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  RECEPTION_STATUS_ID_LIST: {
    // 仮予約
    TENTATIVE_BOOKING: 1,
    // 予約確定
    BOOKING_FIXED: 2,
    // 待機中(新規)
    WAITING: 3,
    // 待機中(無応答)
    NO_REPLY: 4,
    // 待機中(要確認)
    CONFIRMATION_REQUIRED: 5,
    // 待機中(時間超過)
    OVER_TIME: 6,
    // 呼出中
    CALLING: 7,
    // 入場待ち(呼出OK)
    ENTRANCE_WAITING: 8,
    // 作業中
    WORKING_STATE: 9,
    // 作業終了
    FINISH_WORK: 10,
    // キャンセル
    CANCEL: 11,
    // 未受付
    NO_RECEPTION: 12,
    // 入構済
    ENTRANCE: 13,
    // 退門済
    NOT_ENTRANCE: 14
  },

  /**
   * 受付データのAPIキーリスト
   * @name RECEPTION_DATA_API_KEY_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  RECEPTION_DATA_API_KEY_LIST: {
    BERTH_CATEGORY_ID: 'berth_category_id',
    RECEPTION_STATUS_ID: 'reception_status_id',
    RECEPTION_GATE_ID: 'gate_id'
  },

  /**
   * 受付一覧検索パラメータ種別
   * @name RECEPTION_SEARCH_PARAM_TYPE
   * @constant
   * @memberOf const.CenterConst
   */
  RECEPTION_SEARCH_PARAM_TYPE: {
    TARGET_DATE: 'targetDate',
    START_TIME: 'startTime',
    END_TIME: 'endTime'
  },

  /**
   * 最終時刻
   * @name END_TIME_OF_DATE
   * @constant
   * @memberOf const.CenterConst
   */
  END_TIME_OF_DATE: '23:59',

  /**
   * 呼出結果
   * @name CALL_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  CALL_RESULT: {
    SUCCESS: '1',
    NO_REPLY: '2',
    CONFIRMATION_REQUIRED: '3',
    OTHER: '4',
    INVALID_TEL_NUMBER: '5',
    OVERLAP: '6'
  },

  /**
   * 受付一覧取得結果
   * @name RECEPTION_LIST_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  RECEPTION_LIST_RESULT: {
    SUCCESS: '1',
    PERIOD_INVALID: '2',
    BERTH_CATEGORY_INVALID: '3',
    TRANSPORTER_INVALID: '4',
    BOOKING_STATUS_INVALID: '5',
    OTHER: '9'
  },

  /**
   * 実績管理強化のタイプ
   * @name PERFORMANCE_OPTION
   * @constant
   * @memberOf const.CenterConst
   */
  PERFORMANCE_OPTION: {
    // 標準
    NOMAL: 0,
    // 簡易
    SIMPLE: 1,
    // 詳細
    DETAIL: 2
  },

  /**
   * 実績一覧取得結果
   * @name ACHIEVEMENT_LIST_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  ACHIEVEMENT_LIST_RESULT: {
    SUCCESS: '1',
    PERIOD_INVALID: '2',
    OVER_COUNT: '3',
    OTHER: '9'
  },

  /**
   * 実績詳細取得結果
   * @name ACHIEVEMENT_LIST_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  ACHIEVEMENT_DETAIL_RESULT: {
    SUCCESS: '1',
    NO_DATA: '2',
    NO_RECEPTION: '3',
    OTHER: '9'
  },

  /**
   * 実績日時IDリスト
   * @name PERFORMANCE_TIME_ID_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  PERFORMANCE_TIME_ID_LIST: {
    // 仮予約開始日時
    TENTATIVE_BOOKING_START_TIME: '1',
    // 割り当て確定日時
    ASSIGN_CONFIRM_TIME: '2',
    // 入場日時
    ENTRANCE_TIME: '3',
    // 受付日時
    RECEPTION_TIME: '4',
    // 呼出日時
    CALLING_TIME: '5',
    // 呼出応答日時
    CALLING_RESPONCE_TIME: '6',
    // 作業開始日時
    WORKING_START_TIME: '7',
    // 作業終了日時
    WORKING_END_TIME: '8',
    // 退場日時
    LEAVING_TIME: '9'
  },

  /**
   * 受付状態更新結果
   * @name RECEPTION_UPDATE_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  RECEPTION_UPDATE_RESULT: {
    SUCCESS: '1',
    ID_INVARID: '2',
    NO_UPDATE_AUTHORITY: '3',
    STATUS_INVARID: '4'
  },

  /**
   * 署名画像のファイル名用定義
   * @name SIGN_FILE_NAME
   * @constant
   * @memberOf const.CenterConst
   */
  SIGN_FILE_NAME: {
    NAME: 'sign_',
    EXTENSION: '.png'
  },

  /**
   * 受付状況(混雑状況)取得結果
   * @name BUSY_STATUS_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  BUSY_STATUS_RESULT: {
    SUCCESS: '1',
    PERIOD_INVALID: '2',
    OTHER: '9'
  },

  /**
   * 実績データのAPIキーリスト
   * @name PERFORMANCE_DATA_API_KEY_LIST
   * @constant
   * @memberOf const.CenterConst
   */
  PERFORMANCE_DATA_API_KEY_LIST: {
    BERTH_CATEGORY_ID: 'berth_category_id',
    SUB_STATUS_ID: 'sub_status_id'
  },

  /**
   * 実績一覧検索パラメータ種別
   * @name PERFORMANCE_SEARCH_PARAM_TYPE
   * @constant
   * @memberOf const.CenterConst
   */
  PERFORMANCE_SEARCH_PARAM_TYPE: {
    START_DAY: 'startDay',
    END_DAY: 'endDay'
  },

  /**
   * 実績一覧検索パラメータ種別
   * @name PERFORMANCE_SEARCH_PARAM_TYPE
   * @constant
   * @memberOf const.CenterConst
   */
  CAR_SEARCH_PARAM_TYPE: {
    REGIST_DAY: 'registDay'
  },

  /**
   * ユーザー登録結果
   * @name USER_REGIST_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  USER_REGIST_RESULT: {
    SUCCESS: '1',
    USER_ID_DUPLICATE: '2',
    OTHER: '9'
  },

  /**
   * ユーザー編集結果
   * @name USER_EDIT_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  USER_EDIT_RESULT: {
    SUCCESS: '1',
    USER_ID_DUPLICATE: '2',
    MISSING_NUMBER: '3',
    NOT_EXIST: '4',
    OTHER: '9'
  },

  /**
   * 予約編集結果コード
   * @name BOOKING_EDIT_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  BOOKING_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // バース種別が無効
    INVALID_BERTH_CATEGORY: '2',
    // バースがすべて無効
    INVALID_BERTH: '3',
    // 利用可能日・時間外
    OUTSIDE: '4',
    // 予約枠超過
    FULL: '5',
    // 予約IDが無効
    INVALID_ID: '6',
    // 予約可能日範囲外
    BOOKING_PERIOD_OUTSIDE: '7',
    // 更新不可項目が含まれている
    UNEDITABLE_ITEM: '8',
    // その他エラ－
    OTHER: '9',
    // 配送会社名が無効
    CONTRACTOR_ID_ERROR: '10'
  },

  /**
   * 実績編集結果コード
   * @name ACHIEVEMENT_EDIT_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  ACHIEVEMENT_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // 受付情報が存在しない
    NOT_EXITS_RECEITON: '2',
    // サブステータス情報が存在しない
    NOT_EXIST_SUB_STATUS: '3',
    // 作業開始日付相関エラー
    INVALID_DATE: '4'
  },

  /**
   * コンテナ
   * @name CONTAINER_BERTH_CATEGORY_ID
   * @constant
   * @memberOf const.CenterConst
   */
  CONTAINER_BERTH_CATEGORY_ID: '3',

  /**
   * 検温オプション
   * 測定結果
   *
   * @name THERMOMETER_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  THERMOMETER_RESULT: {
    // 不定
    INDEFINITE: '0',
    // 正常
    SUCCESS: '1',
    // 異常
    ERROR: '2',
    // 測定エラー
    MEASUREMENT_ERROR: '8',
    // 機器エラー
    DEVICE_ERROR: '9'
  },

  /**
   * 検温オプション
   * アンケート結果
   *
   * @name ENQUETE_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  ENQUETE_RESULT: {
    // 不定
    INDEFINITE: '0',
    // 正常
    SUCCESS: '1',
    // 異常
    ERROR: '2'
  },

  /**
   * 検温オプション
   * 測定値のフォーマット変換用定義
   *
   * @name THERMOMETER_TEMPARATURE_CONVERT
   * @constant
   * @memberOf const.CenterConst
   */
  THERMOMETER_TEMPARATURE_CONVERT: {
    // 置き換え文字列
    REPLACE_TEXT: '.0'
  },

  /**
   * 受付編集結果コード
   * @name RECEPTION_EDIT_RESULT
   * @constant
   * @memberOf const.ContractorConst
   */
  RECEPTION_EDIT_RESULT: {
    // 成功
    SUCCESS: '1',
    // 指定の受付IDが存在しない
    INVALID_RECEPTION_ID: '2',
    // 指定の車種が存在しない
    INVALID_CAR_CATEGORY: '3',
    // 同一の電話番号の受付が存在する
    EXIST_SAME_PHONE_NUMBER: '4'
  },

  /**
   * 予約割当画面で表示する日付
   * 住友理工カスタマイズ 新規追加
   * @name BOOKING_ASSIGN_DISPLAY_SETTING
   * @constant
   * @memberOf const.CenterConst
   */
  BOOKING_ASSIGN_DISPLAY_SETTING: {
    // 表示する利用日以前の日数
    START_DATE: -1,
    // 表示する利用日以降の日数
    END_DATE: 1
  },

  /**
   * 作業登録状態
   * @name REGIST_WORKING_STATUS
   * @constant
   * @memberOf const.ContractorConst
   */
  REGIST_WORKING_STATUS: {
    // 通常
    NORMAL: 0,
    // 作業開始
    START: 1,
    // 作業終了
    END: 2
  },

  /**
   * 実績登録結果コード
   * @name ACHIEVEMENT_REGIST_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  ACHIEVEMENT_REGIST_RESULT: {
    // 成功
    SUCCESS: '1',
    // 予約IDが無効
    INVALID_BOOKING_ID: '2',
    // 実績IDが無効
    INVALID_PERFORMANCE_ID: '3'
  },

  /**
   * バース削除結果コード
   * @name BERTH_DELETE_RESULT
   * @constant
   * @memberOf const.CenterConst
   */
  BERTH_DELETE_RESULT: {
    // 成功
    SUCCESS: '1',
    // 予約IDが無効
    INVALID_DELETE: '2'
  }
};
export default CenterConst;



// WEBPACK FOOTER //
// ./src/js/const/CenterConst.jsx